export default __webpack_public_path__ + "static/media/emptyHeart.e04d2b0b.svg";